import { IKnmErknmFormViolatedRequirementsNpa } from '../interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { IKnmErknmFormRequirementNpa } from '../interfaces/IKnmErknmFormRequirementNpa';

export function convertIKnmErknmFormViolatedRequirementsNpaToIKnmErknmFormRequirementNpa(
  requirementsNpa: IKnmErknmFormViolatedRequirementsNpa[] | null | undefined,
): IKnmErknmFormRequirementNpa[] | undefined {
  return requirementsNpa?.map<IKnmErknmFormRequirementNpa>(item => ({
    guid: null,
    npa: item.npa,
    structuralUnit: item.structuralUnit,
    inspectionResults: undefined,
    mandatory: item.violatedMandatory,
  }));
}
